import { Color, ShaderMaterial } from 'three';

import fragmentShader from './shaders/fragmentShader';
import vertexShader from './shaders/vertexShader';

export default class Material extends ShaderMaterial {
    constructor() {
        super({
            vertexShader,
            fragmentShader,
            uniforms: {
                noiseMap: { value: null },
                time: { value: 0 },
                colorA: { value: new Color('rgb(27,	15, 70)') },
                colorB: { value: new Color('rgb(55,	1,	45)') },
                noiseScaleA: { value: 0.1 },
                noiseScaleB: { value: 0.11 },
                strength: { value: 0.8 },
                opacity: { value: 1.0 },
            },
            transparent: true,
        });
    }
}
